export const navArr = [
    {
        title: "Молоко",
        path: "milk",
    },
    {
        title: "Масло",
        path: "butter",
    },
    {
        title: "Кисломолочні продукти",
        path: "fermented-milk-products",
    },
    {
        title: "Крафтові продукти",
        path: "craft-products",
    },
]

export const navArrRu = [
    {
        title: "Молоко",
        path: "ru/milk",
    },
    {
        title: "Масло",
        path: "ru/butter",
    },
    {
        title: "Кисломолочные продукты",
        path: "ru/fermented-milk-products",
    },
    {
        title: "Крафтовые продукты",
        path: "ru/craft-products",
    },
]